import { useState } from "react";
import { KeyRound, LogIn, ShieldCheck } from "lucide-react";
import { ApiError, login, type SessionUser } from "../lib/api";
import { BrandMark } from "./BrandMark";

export function Login({ onSuccess }: { onSuccess: (user: SessionUser) => void }) {
  const [code, setCode] = useState("");
  const [pin, setPin] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      onSuccess(await login(code, pin));
    } catch (reason) {
      setError(reason instanceof ApiError ? reason.message : "เข้าสู่ระบบไม่ได้ กรุณาลองอีกครั้ง");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-panel" aria-labelledby="login-title">
        <BrandMark />
        <div className="login-copy">
          <h1 id="login-title">เข้าสู่ระบบลงเวลา</h1>
          <p>ใช้รหัสพนักงานและ PIN ที่ได้รับจากผู้จัดการ</p>
        </div>
        <form className="login-form" onSubmit={submit}>
          <label>รหัสพนักงาน<input autoComplete="username" autoCapitalize="characters" value={code} onChange={(event) => setCode(event.target.value.toUpperCase())} placeholder="เช่น EMP001" required /></label>
          <label>PIN 6 หลัก<div className="login-pin"><KeyRound size={19} /><input type="password" inputMode="numeric" pattern="[0-9]{6}" maxLength={6} autoComplete="current-password" value={pin} onChange={(event) => setPin(event.target.value.replace(/\D/g, "").slice(0, 6))} placeholder="••••••" required /></div></label>
          {error && <p className="form-error" role="alert">{error}</p>}
          <button className="button primary large" disabled={submitting || code.length < 3 || pin.length !== 6}><LogIn size={20} />{submitting ? "กำลังเข้าสู่ระบบ…" : "เข้าสู่ระบบ"}</button>
        </form>
        <p className="login-trust"><ShieldCheck size={16} /> บัญชีแต่ละคนแยกกัน รูปและเวลาจะผูกกับผู้ลงเวลาโดยตรง</p>
      </section>
    </main>
  );
}
